module.exports = __webpack_public_path__ + "static/media/input_data_template.92c4b07d.csv";